import { SAVE_REQUESTS } from './actionTypes'
import { RequestsType } from './types'
import { RequestItemModel } from '../../requests/requestsModel'

export const saveRequests = (contracts: Partial<RequestItemModel>[]): RequestsType => {
	return ({
		type: SAVE_REQUESTS,
		payload: contracts
	})
}
